import { BuyNowPayLaterMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { InstallmentPaymentMethod } from '../../types/InstallmentPaymentMethod';
import { DeviceType } from '../../types/DeviceType';
import { DesktopModalSize, MobileModalSize } from '../../common.constants';

export const sortPaymentMethodsByRank = (
  paymentMethods: BuyNowPayLaterMethod[],
): InstallmentPaymentMethod[] | PaymentMethod[] => {
  return paymentMethods
    .sort((aMethod, bMethod) => aMethod.rank - bMethod.rank)
    .map((pm) => pm.paymentMethod as InstallmentPaymentMethod & PaymentMethod);
};

export const getModalSize = (deviceType, paymentMethod, sizeFromServer) =>
  // Gets modal size depends on payment method, gracefully falling back to the default size (which is Afterpay)
  deviceType === DeviceType.Mobile
    ? MobileModalSize
    : sizeFromServer || DesktopModalSize?.[paymentMethod] || DesktopModalSize[InstallmentPaymentMethod.Afterpay];
